import { GraphQLClient } from '../components/GraphQL';

class BaseService {
  constructor(uri) {
    const graphQLClient = new GraphQLClient(uri);
    this.client = graphQLClient.client;
  }
}

export default BaseService;
